
const remote = 'https://bruehmleague.com/api/';
const local = 'http://localhost:8080/'
var backend = remote;

if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
  backend = local;
}


function sendRequest(url) {
  console.log("Trying to Fetch from: " + url);
  fetch(url)
    .then(response => response.json())
    .then(json =>  console.log(json))
    .catch(error => {
      console.log(error);
      return "Didnt get an answer";
  });
}

function testHttpSBruehm() {
  sendRequest(backend  + 'person');
}


function MyButton() {
  return(
    <button onClick={testHttpSBruehm}>Testing Bruehm</button>
  )
}



export default function About() {
  return (
    <div>
      <h1>Button Testing</h1>
      <div>
        <MyButton />
      </div>
    </div>
  );
}


